import React from 'react';
import PropTypes from 'prop-types';
import MessageProgress from './MessageProgress';

const MessageContent = ({ content, actions, duration, showProgress }) => {
  return (
    <div className="acast-message__content">
      {content}
      {actions?.length > 0 && <div className="acast-message__actions">{actions}</div>}
      {duration > 0 && showProgress && <MessageProgress duration={duration} />}
    </div>
  );
};

export default MessageContent;

MessageContent.propTypes = {
  content: PropTypes.node.isRequired,
  actions: PropTypes.arrayOf(PropTypes.node),
  duration: PropTypes.number,
  showProgress: PropTypes.bool,
};
